import { FC, ReactNode } from "react";
import { useClientsCloseOverviewSlimQuery } from "@api/workspace.api";
import { isFeatureDisabledError } from "@api/featureDisabledError";
import { StateAwareNavigate } from "@components/routes/StateAwareNavigate";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";

interface ClientsCloseOverviewRouteGateProps {
    organizationId: string;
    children: ReactNode;
}

export const ClientsCloseOverviewRouteGate: FC<
    ClientsCloseOverviewRouteGateProps
> = ({ organizationId, children }) => {
    const { error, isPending } = useClientsCloseOverviewSlimQuery(
        {
            organizationId,
            page: 1,
            limit: 1,
        },
        { retry: false },
    );

    if (!organizationId) {
        return <PageCoverLoader />;
    }

    if (isPending) {
        return <PageCoverLoader />;
    }

    if (isFeatureDisabledError(error)) {
        return <StateAwareNavigate to="/clients" replace />;
    }

    return children;
};
